
<template>
  <div class="zm-checkbox-group" role="group" :class="[size ? 'zm-checkbox-group--' + size : '']">
    <slot></slot>
  </div>
</template>

<script>
  import Emitter from '../../mixins/emitter';

  export default {
    name: 'ZmCheckboxGroup',

    componentName: 'ZmCheckboxGroup',

    mixins: [Emitter],

    inject: {
      ZmFormItem: {
        default: ''
      }
    },

    props: {
      value: {},
      disabled: Boolean,
      size: String
    },

    computed: {
      _elFormItemSize() {
        return (this.ZmFormItem || {}).elFormItemSize;
      },
      checkboxGroupSize() {
        return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      }
    },

    watch: {
      value(value) {
        this.dispatch('ZmFormItem', 'el.form.change', [value]);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";
  @import "../../scss/mixins/button";


  @include b(checkbox-group) {
    &[vertical] .zm-checkbox{
      display: block;
      margin-right: 0;
    }
    &[buttonstyle] .zm-checkbox{
      margin-right: 0;
      .zm-checkbox-wrap{
        padding-left: 0;
      }
      .zm-checkbox__inner{
        display: none;
      }

      .zm-checkbox__label{
        display: inline-block;
        white-space: nowrap;
        vertical-align: middle;
        border: $--border-base;
        border-left: 0;
        color: $--color-text-primary;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        position: relative;
        cursor: pointer;
        transition: $--all-transition;
        line-height: $--button-height - 2;
        @include button-size(0, $--button-padding-horizontal, $--button-font-size, 0);

        &:hover {
          color: $--color-primary;
        }

        & [class*="zm-icon-"] {
          line-height: 0.9;

          & + span {
            margin-left: 5px;
          }
        }
      }

      &:first-child {
        .zm-checkbox__label {
          border-left: $--border-base;
          border-radius: $--border-radius-base 0 0 $--border-radius-base;
        }
      }

      .zm-checkbox__original {
        &:checked {
          & ~ .zm-checkbox__label {
            color: $--radio-button-checked-color;
            background-color: $--radio-button-checked-fill;
            border-color: $--radio-button-checked-border-color;
            box-shadow: -1px 0 0 0 $--radio-button-checked-border-color;
          }
        }

        &:disabled {
          & ~ .zm-checkbox__label {
            color: $--button-disabled-color;
            cursor: not-allowed;
            background-image: none;
            background-color: $--button-disabled-fill;
            box-shadow: none;
          }
          &:checked ~ .zm-checkbox__label {
            background-color: $--radio-button-disabled-checked-fill;
          }
        }
      }

      &:last-child {
        .zm-checkbox__label {
          border-radius: 0 $--border-radius-base $--border-radius-base 0;
        }
      }

      &:first-child:last-child {
        .zm-checkbox__label {
          border-radius: $--border-radius-base;
        }
      }
    }
    @include m(large) {
      &[buttonstyle] .zm-checkbox .zm-checkbox__label {
        line-height: $--button-lg-height - 2;
        @include button-size(0, $--button-lg-padding-horizontal, $--button-lg-font-size, 0);
      }
    }
    @include m(small) {
      &[buttonstyle] .zm-checkbox .zm-checkbox__label {
        line-height: $--button-small-height - 2;
        @include button-size(0, $--button-small-padding-horizontal, $--button-small-font-size, 0);
      }
    }
  }
  .is-keyboard-event .zm-checkbox-group[buttonstyle] .zm-checkbox__original:focus:not(:active):not(:disabled) ~ .zm-checkbox__label{
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px $--color-primary;
  }
</style>
